import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;

  small {
    color: var(--color-text-muted);
  }

  .buttonContainer {
    width: 300px;
    max-width: 100%;
    display: flex;
    grid-gap: 10px;
    justify-content: center;
    margin: 0 auto;
  }
`;
